module.exports = __webpack_public_path__ + "img/a2.e8a7c1c5.png";